<template>
  <div class="wrapper">
    <button @click="save" class="mt-3 btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button><br/>
    <div class="row mt-3">
      <div class="col-md">
        <div class="card">
          <div class="card-header">Telegram</div>
          <div class="card-body" id="conftelegram">
            <div class="form-group">
              <label>Name:</label>
              <input class="form-control" v-model="telegram.name" type="text"/>
            </div>
            <div class="form-group">
              <label>Token:</label>
              <input class="form-control" v-model="telegram.token" type="text"/>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md">
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'

export default {
  name: 'ChatBotClientConfig',
  data() {
    return {
      telegram: {},
    }
  },
  created: function() {
    var self = this;
    config.loadcfg(["if.proxy.telegram.bot"],this,function(data) {
      if (data['if.proxy.telegram.bot'] !== '') {
        self.telegram = JSON.parse(data['if.proxy.telegram.bot'])
      }
    })
  },
  methods: {
    save: function() {
      console.log(this.telegram);
      var self = this;
      var data = {};
      data['if.proxy.telegram.bot'] = JSON.stringify(this.telegram);

      config.savecfg(data,this,function() {
        self.$bvToast.toast('Endpunkte gesichert',{title: 'Chat Bot',variant:'success'})
      });
    }
  }
}
</script>
